import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { TPaginationParams } from '../../../../apis/__shared/shared.interfaces';
import { IDriversResponse } from 'src/apis/administration/administration.interfaces';
import { useRoutesAndSchedulesService } from 'src/apis/administration/useRoutesAndSchedulesService';

type TQueryError = IFHError<{ message: string }>;
export const getDriverListKey = 'get-driver-list';

export const useDriverListHook = (
  params: TPaginationParams,
  options?: UseQueryOptions<IDriversResponse, TQueryError>
): UseQueryResult<IDriversResponse, TQueryError> => {
  const { getDriverList } = useRoutesAndSchedulesService();

  return useQuery<IDriversResponse, TQueryError>({
    queryKey: [getDriverListKey, params],
    queryFn: () => getDriverList(params),
    enabled: true,
    ...options,
  });
};
